<script setup>
import { calendarWeeks } from '../helpers/DatePickerHelper';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
</script>

<template>
  <div class="max-w-md mx-auto grid grid-cols-7 gap-2">
    <div
      v-for="day in calendarWeeks"
      :key="day.id"
      class="flex items-center justify-center font-medium text-sm w-9 h-7 py-1.5 px-2"
    >
      {{ t(`DATE_PICKER.WEEKDAYS.${day.id}`) }}
    </div>
  </div>
</template>
